import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';

import App from './App';

import TABS from './tabs';

import { setActiveTab, init, setMode, setAppStatus } from '@reducers/actions';
import ObjectView from '@scene/views/object-view';
import { initProfile } from '@reducers/web-services/profile/actions';
import { APP_STATES } from '@config';
import { activateDesignCombination } from '@reducers/selectors/design/actions';
import { PerspectiveCameraTypes, setPerspectiveCameraType } from '@reducers/camera/actions';

const mapState = state => ({
  activeTab: state.main.activeTab,
  isEditor: state.main.mode === ObjectView.mode.MODE_2D_EDITOR,
  appStatus: state.main.status,
  projectName: state.main.projectName,
  country: state.main.localization.country,
  allowCalculation:
    (!state.webServices.calculate.grid || !state.webServices.calculate.grid.length || state.webServices.calculate.grid.length <= 0) &&
    !state.webServices.calculate.isWaiting, // empty list and not running any calculation 
});

const mapDispatch = dispatch => ({
  setActiveTab: tab => {

    if (tab === TABS.APPLICATION) {
      dispatch(setPerspectiveCameraType(PerspectiveCameraTypes.zoom_out));
    }

    if (tab === TABS.LOADS) {
      dispatch(setMode(ObjectView.mode.MODE_3D));
    }

    if (tab === TABS.DESIGN) {
      dispatch(activateDesignCombination());
    }

    if (tab === TABS.OPTIONS) {
      dispatch(setAppStatus(APP_STATES.REVIEW_OPTIONS));
    }
    else {
      dispatch(setAppStatus(APP_STATES.INITIALIZED));
    }

    dispatch(setActiveTab(tab));
  },
  init: async () => {
    dispatch(initProfile());
    await dispatch(init());
  }
});

export default connect(
  mapState,
  mapDispatch
)(hot(module)(App));



// WEBPACK FOOTER //
// ./src/App/index.js